var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"svg-icon center-block",style:(_vm.style)},[_c(_vm.dynamicIcon,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }